export default function times(n,f){
  for (let i = 0; i < n; i++) {
    f.call(this,i);
  }
}



// WEBPACK FOOTER //
// ./src/js/screens/Screen3/water/times.js